export enum OPEN_SETTINGS {
  ApplicationDetails = 'application_details',
  Bluetooth = 'bluetooth',
}
